/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramChatsUserControllerFindOneQueryResponse,
  TelegramChatsUserControllerFindOnePathParams,
  TelegramChatsUserControllerFindOne401,
  TelegramChatsUserControllerFindOne403,
  TelegramChatsUserControllerFindOne404,
} from '../../types/TelegramChatsUserControllerFindOne.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramChatsUserFindOne } from '../../methods/telegramChatsUserFindOne.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramChatsUserFindOneQueryKey = (id: TelegramChatsUserControllerFindOnePathParams['id']) =>
  [{ url: '/api/user/telegram/chats/:id', params: { id: id } }] as const;

export type TelegramChatsUserFindOneQueryKey = ReturnType<typeof telegramChatsUserFindOneQueryKey>;

export function telegramChatsUserFindOneQueryOptions(
  id: TelegramChatsUserControllerFindOnePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramChatsUserFindOneQueryKey(id);
  return queryOptions<
    TelegramChatsUserControllerFindOneQueryResponse,
    ResponseErrorConfig<
      | TelegramChatsUserControllerFindOne401
      | TelegramChatsUserControllerFindOne403
      | TelegramChatsUserControllerFindOne404
    >,
    TelegramChatsUserControllerFindOneQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramChatsUserFindOne(id, config);
    },
  });
}

/**
 * {@link /api/user/telegram/chats/:id}
 */
export function useTelegramChatsUserFindOne<
  TData = TelegramChatsUserControllerFindOneQueryResponse,
  TQueryData = TelegramChatsUserControllerFindOneQueryResponse,
  TQueryKey extends QueryKey = TelegramChatsUserFindOneQueryKey,
>(
  id: TelegramChatsUserControllerFindOnePathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramChatsUserControllerFindOneQueryResponse,
        ResponseErrorConfig<
          | TelegramChatsUserControllerFindOne401
          | TelegramChatsUserControllerFindOne403
          | TelegramChatsUserControllerFindOne404
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramChatsUserFindOneQueryKey(id);

  const query = useQuery(
    {
      ...telegramChatsUserFindOneQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | TelegramChatsUserControllerFindOne401
      | TelegramChatsUserControllerFindOne403
      | TelegramChatsUserControllerFindOne404
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
